import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'
import Modal from '@/components/modalBase/modalBase'
import Loading from '@/components/loading/loading'

@Component({
  components: {
    Modal,
    Loading
  }
})
export default class ModalCoupon extends Vue {
  @Prop({ default: false }) isShow!: Boolean

  @Action action_postCouponsAtivate
  @Action action_activateCartCoupon
  @Action action_deactivateCartCoupon

  @Getter getCart: any

  code = ''
  error = ''
  validatingCoupon = false;

  @Watch('code')
  onCode () {
    this.error = ''
  }

  get getIsCouponApplied() {
    return this.getCart && this.getCart.coupon_applied && this.getCart.coupon_data;
  }

  async _validateCoupon () {
    this.validatingCoupon = true;
    if (this.code && this.code.length) {
      try {
        const data = {
          coupon: {
            code: this.code
          }
        };
        const res = await this.action_activateCartCoupon(data);
        
        if(this.getCart && this.getCart.coupon_applied && this.getCart.coupon_data) {
          this.$emit("close-modal");
        }
      } catch (error) {
        this.error =
          error && error.response && error.response.data && error.response.data.message;
        const status = error && error.response && error.response.status;
        if (status >= 500) {
          this.$emit("close-modal");
          this.$swal({
            title: "Error al validar el cupónn...",
            text: `Problemas con el servidor. Error ${status}`
          });
          //        let message = 'Ayuda! \nMe está saliendo un error con el servidor.';
          //        (window as any).Intercom('showNewMessage', message)
        }
      }
    }
    this.validatingCoupon = false;
  }

  @Watch('getCart', { deep: true })
  onCartChange() {
    if(this.getCart && this.getCart.coupon_applied && this.getCart.coupon_data) {
      const coupon = this.getCart.coupon_data;
      if(coupon.code && coupon.code.length) {
        this.code = coupon.code;
      }
    }
  }

}
